import { useProductSelector } from '@wajeez-web/stores/product';

export const useCreatePolicyMultilingual = () => {
  return useProductSelector(({ policies }) => policies.createMultilingual);
};

export const useEditPolicyMultilingual = () => {
  return useProductSelector(({ policies }) => policies.editMultilingual);
};

export const useGetPolicyByIdMultilingual = () => {
  return useProductSelector(({ policies }) => policies.byIdMultilingual);
};
